import { Input }                          from '@chakra-ui/react';
import { InputGroup }                     from '@/components/ui/input-group';
import { LuSearch }                       from "react-icons/lu";
import { useTranslation }                 from 'react-i18next';

interface INavigationSearchProps {
    searchInputValue: string;
    setSearchInputValue: React.Dispatch<React.SetStateAction<string>>;
}

const NavigationSearch = (props: INavigationSearchProps) => {
    const { searchInputValue, setSearchInputValue } = props;
    const { t } = useTranslation();
    return (
        <InputGroup
            flex="1"
            startElement={<LuSearch />}
        >
            <Input 
                value={searchInputValue}
                bg="#F1F2F1" 
                borderColor="#CACACA" 
                placeholder={t('components.drawer.actions.search')} 
                onChange={(event) => setSearchInputValue(event.target.value)}
            />
        </InputGroup>
    )
}

export default NavigationSearch;